import { Link } from 'react-router-dom'
import { Skeleton } from '@/components/ui/skeleton'
import { Button } from '@/components/ui/button'
import { GradientHoverCard } from '@/components/common/GradientHoverCard'
import { useFestivals } from '../hooks/useFestivals'
import type { FestivalDocument } from '@/types'

function FestivalCard({ festival }: { festival: FestivalDocument & { id: string } }) {
  return (
    <GradientHoverCard>
      <div className="flex flex-col gap-4 rounded-xl p-8">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">{festival.name}</h2>
          <p className="mt-1 text-sm font-medium uppercase tracking-widest text-brand-orange">
            {festival.tagline}
          </p>
        </div>
        <p className="text-muted-foreground leading-relaxed flex-1">{festival.description}</p>
        <div>
          <Button asChild>
            <Link to={`/festivals/${festival.slug}`}>Learn More</Link>
          </Button>
        </div>
      </div>
    </GradientHoverCard>
  )
}

export function FestivalsPage() {
  const { festivals, loading, error } = useFestivals()

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="mb-12 max-w-2xl">
        <p className="mb-3 text-sm font-semibold uppercase tracking-widest text-brand-orange">
          Festivals
        </p>
        <h1 className="mb-4 text-4xl font-bold tracking-tight">
          Platforms for artists, built by artists.
        </h1>
        <p className="text-muted-foreground leading-relaxed">
          One Day Dance runs two recurring festivals dedicated to creating real opportunities for
          choreographers and performers — on screen and on stage.
        </p>
      </div>

      {loading && (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {Array.from({ length: 2 }).map((_, i) => (
            <Skeleton key={i} className="h-64 w-full rounded-xl" />
          ))}
        </div>
      )}

      {error && <p className="text-sm text-destructive">{error}</p>}

      {!loading && !error && (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {festivals.map((festival) => (
            <FestivalCard key={festival.id} festival={festival} />
          ))}
        </div>
      )}
    </div>
  )
}
